enum ServicesTypesEnum {
	HEALTH = 'health',
	EXAMS = 'exams',
	ODONTO = 'odonto',
	TELEHEALTH = 'telehealth',
	EMERGENCY_TELEHEALTH = 'emergency-telehealth',
	AUTHORIZATIONS = 'authorizations',
	OTHERS = 'others',
}

export {ServicesTypesEnum};
